import { defineMessages } from '@jutro/locale';

export default defineMessages({
    additionalDetailsHeader: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Additional Details',
        defaultMessage: 'Additional Details'
    },
    verifyingVins: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Verifying VINs',
        defaultMessage: 'Verifying VIN\'s'
    },
    vehicleX: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.vehicleX',
        defaultMessage: '(Vehicle #{vehicleNumber})'
    },
    driverX: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.driverX',
        defaultMessage: '(Driver #{driverNumber})'
    },
    excludedDriverX: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.excludedDriverX',
        defaultMessage: '(Excluded Driver #{driverNumber})'
    },
    watercraftOperatorX: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.watercraftOperatorX',
        defaultMessage: '(Watercraft Operator #{watercraftOperatorNumber})'
    },
    serialNumber: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Serial Number',
        defaultMessage: 'Serial Number'
    },
    enterSerialNumber: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    },
    driverLicense: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Driver License',
        defaultMessage: 'Driver\'s License'
    },
    stateLicensed: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.State Licensed',
        defaultMessage: 'State Licensed'
    },
    ageFirstLicensed: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    },
    emailAddress: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Email Address',
        defaultMessage: 'Email Address'
    },
    enterEmailAddress: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Enter Email Address',
        defaultMessage: 'Enter Email Address'
    },
    occupation: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Occupation',
        defaultMessage: 'Occupation'
    },
    ocupationTooltip: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.occupationTooltip',
        defaultMessage: 'Where permissible by law, your occupation is one of the factors used in determining your rate, as well as, your eligibility for discounts.'
    },
    ocupationTooltipTitle: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.occupationTooltipTitle',
        defaultMessage: 'Why do you need my occupation?'
    },
    licenseStateTooltip: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.licenseStateTooltip',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
    licenseStateTooltipTitle: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.licenseStateTooltipTitle',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    yearsOperatingWatercraft: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Years Operating Watercraft',
        defaultMessage: 'Years Operating Watercraft'
    },
    licenseNumber: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.License Number',
        defaultMessage: 'License Number'
    },
    licenseState: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.License State',
        defaultMessage: 'License State'
    },
    hasLossWithin5Years: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.Have there been any umbrella or personal liability losses in the last 5 years?',
        defaultMessage: 'Have there been any umbrella or personal liability losses in the last 5 years?'
    },
    reviewAdditionalActivity: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.review for any additional activity',
        defaultMessage: 'review for any additional activity'
    },
    mvrsMayBeRun: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.MVRs may be run',
        defaultMessage: 'MVRs may be run'
    },
    nextDesc: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.nextDesc',
        defaultMessage: 'We\'ll {reviewAdditionalActivity} next and {mvrsMayBeRun}'
    },
    errorMsg: {
        id: 'ml.gateway.policyChange.pup.additionalInfoToPurchase.errorMsg',
        defaultMessage: 'Watercraft operator license number must be unique.'
    },
    invalidEmail:{
        id:'ml.gateway.policyChange.pup.additionalInfoToPurchase.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    duplicateLicenseError:{
        id:'ml.gateway.policyChange.pup.additionalInfoToPurchase.License numbers must be unique',
        defaultMessage:"License numbers must be unique."
    },
});
